;(function () {
  'use strict';

  let angular = window.angular;

  UserService.$inject = ['$q', 'Manager', 'Customer', 'LoopBackAuth', 'AppUtils'];

  angular
    .module('appServices')
    .service('UserService', UserService);

  function UserService ($q, Manager, Customer, LoopBackAuth, utils) {
    return {
      getCurrent: getCurrent,
      findById: findById,
      saveProfile: saveProfile,
      changePassword: changePassword,
      setPassword: setPassword,
      getUserImageUrl: getUserImageUrl,
      getModel: getModel
    };

    function getCurrent () {
      return Manager
        .getCurrent()
        .$promise
        .catch(err => {
          throw utils.getHTTPError(err);
        });
    }

    function findById (userId, filter) {
      filter = filter || {};

      return Manager
        .findById({
          id: userId,
          filter: filter
        })
        .$promise
        .catch(err => {
          throw utils.getHTTPError(err);
        });
    }

    function getUserImageUrl (user, property) {
      let model = getModel();
      property = property || '_profile';
      if (user.container && user.container[property]) {
        let file = user.container[property];
        property = property.replace('_', '');
        return utils.getEntityFileUrl(model, user.id, property, file, LoopBackAuth.accessTokenId);
      }
    }

    function getModel () {
      return Manager.modelName;
    }

    function changePassword (user, oldPassword, newPassword) {
      return Manager
        .changePassword({
          id: user.id
        }, {
          oldPassword: oldPassword,
          newPassword: newPassword
        })
        .$promise
        .catch(err => {
          return Promise.reject(utils.getHTTPError(err));
        })
    }

    function setPassword (userId, newPassword) {
      return Manager
        .setPassword({
          id: userId,
          newPassword: newPassword
        })
        .$promise
        .catch(err => {
          return Promise.reject(utils.getHTTPError(err));
        })
    }

    function saveProfile (user) {
      return Manager
        .prototype$patchAttributes({
          id: user.id
        }, {
          name: user.name,
          surname: user.surname,
          //email: vm.user.email,
          phone: user.phone,
          birthday: user.birthday,
          address: user.address,
          countryId: user.countryId,
          timeZoneId: user.timeZoneId,
          passwordConfirmation: user.passwordConfirmation
        })
        .$promise
        .catch(err => {
          throw utils.getHTTPError(err);
        });
    }
  }
})();
